var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeExplorerPref(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.66667C0 1.20643 0.373096 0.833333 0.833333 0.833333H8.33333C8.79357 0.833333 9.16667 1.20643 9.16667 1.66667V5C9.16667 5.46024 8.79357 5.83333 8.33333 5.83333H0.833333C0.373096 5.83333 0 5.46024 0 5V1.66667Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.833333C0 0.373096 0.373096 0 0.833333 0H3.33333C3.79357 0 4.16667 0.373096 4.16667 0.833333V5C4.16667 5.46024 3.79357 5.83333 3.33333 5.83333H0.833333C0.373096 5.83333 0 5.46024 0 5V0.833333Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 7.5C10.8333 7.03976 11.2064 6.66667 11.6667 6.66667H14.1667C14.6269 6.66667 15 7.03976 15 7.5V11.6667C15 12.1269 14.6269 12.5 14.1667 12.5H11.6667C11.2064 12.5 10.8333 12.1269 10.8333 11.6667V7.5Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.1667C10.8333 13.7064 11.2064 13.3333 11.6667 13.3333H14.1667C14.6269 13.3333 15 13.7064 15 14.1667V18.3333C15 18.7936 14.6269 19.1667 14.1667 19.1667H11.6667C11.2064 19.1667 10.8333 18.7936 10.8333 18.3333V14.1667Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 5.83333H5V20H4.16667V5.83333Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.8333H10.8333V16.6667H5V15.8333Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.16667H10.8333V10H5V9.16667Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 15C10.8333 14.5398 11.2064 14.1667 11.6667 14.1667H19.1667C19.6269 14.1667 20 14.5398 20 15V18.3333C20 18.7936 19.6269 19.1667 19.1667 19.1667H11.6667C11.2064 19.1667 10.8333 18.7936 10.8333 18.3333V15Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 8.33333C10.8333 7.8731 11.2064 7.5 11.6667 7.5H19.1667C19.6269 7.5 20 7.8731 20 8.33333V11.6667C20 12.1269 19.6269 12.5 19.1667 12.5H11.6667C11.2064 12.5 10.8333 12.1269 10.8333 11.6667V8.33333Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeExplorerPref);
export default __webpack_public_path__ + "static/media/TreeExplorerPref.b5642aa2142a195c630da20e3f3f3d6b.svg";
export { ForwardRef as ReactComponent };